import { memo } from 'react';
import classnames from 'classnames';
import { components } from 'react-select';
import { SingleValueCountryProps } from './types';
import s from './index.module.scss';

export const SingleValueCountry = memo(function SingleValueCountry(props: SingleValueCountryProps) {
  const { data: country, isDisabled } = props;
  return (
    <components.SingleValue {...props}>
      <div className={s.value}>
        <div className={classnames(s.flag, isDisabled && s.flag_disabled)}>
          <img src={country.flag} alt={country.label} />
        </div>
        <div className={classnames(s.name, isDisabled && s.name_disabled)}>{country.label}</div>
      </div>
    </components.SingleValue>
  );
});